import React, { useCallback } from 'react';
import { useTempState } from '@starflow/app/store';
import { restoreGenerateParams } from '@shakkerai/pro-utils';
import { Switch } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
import { Icon } from '@shakkerai/components';
import { switchGlobalMode } from '../../helpers/generate';

export const GeneratorPanelFooter = React.memo(({ children, generator }) => {
  const globalMode = useTempState('globalMode');

  const handleRestoreParams = useCallback(() => {
    restoreGenerateParams(generator.id);
  }, [generator.id]);

  const handleToggleAdvancedMode = useCallback(() => {
    switchGlobalMode(globalMode === 'pro' ? 'simple' : 'pro');
  }, [globalMode]);

  if (!generator) {
    return <div className="flex items-center h-[50px] px-4 bg-[#fafafa]" />;
  }

  const isPrimaryGenerator = generator.type === 'generator';

  return (
    <div className={`px-4 bg-[#fafafa] ${isPrimaryGenerator ? '' : 'pt-4'}`}>
      {children}
      <div className="flex items-center h-[50px]">
        <button onClick={handleRestoreParams} className="flex items-center">
          <Icon className="icon-proshauxin" fontSize={18} color="#7F7F7F" />
          <span className="ml-1 text-xs text-[#2d2d2d]">{translate('reset_generate_params')}</span>
        </button>
        <div className="flex-1" />
        <div id="modeSwitchBtn" className="flex">
          <Switch checked={globalMode === 'pro'} onChange={handleToggleAdvancedMode} size="xs" />
          <button onClick={handleToggleAdvancedMode} className="ml-2 text-xs font-semibold text-[#2d2d2d]">
            {translate('advanced_mode')}
          </button>
        </div>
      </div>
    </div>
  );
});
